<template>
    <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-8 offset-xl-2">
            <audio v-if="value.document" :src="value.document.url" controls style="width:100%">
                O seu navegador não suporta o elemento <code>audio</code>.
            </audio>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Audio',
    props:['value']
}
</script>